module.exports = __webpack_public_path__ + "img/new-food-sushi.16cf2a1c.png";